import { initializeApp } from 'firebase/app';
   import { getDatabase } from 'firebase/database';
   import { getStorage } from 'firebase/storage';
   import { getAuth } from 'firebase/auth';
   

   const firebaseConfig = {
      apiKey: "AIzaSyDe0fInfq1wSEIsPUXC22geeystMQlvqDg",
      authDomain: "realbloggeralo.firebaseapp.com",
      databaseURL: "https://realbloggeralo.firebaseio.com",
      projectId: "realbloggeralo",
      storageBucket: "realbloggeralo.appspot.com",
      messagingSenderId: "955684091592",
      appId: "1:955684091592:web:e148e91125602d2b30d7fd",
      
   };

   const app = initializeApp(firebaseConfig);
   
   const database = getDatabase(app);

   // Initialize Storage
   const storage = getStorage(app);
   
   // Initialize Auth
   const auth = getAuth(app);
   
   export { database, storage, auth };
   